import { useApi } from '@/shared/api/http';

import type {
  AuthData,
  OTPData,
  RefreshTokenData,
} from '@/features/AuthForm/model/types/auth';

export const useAuthService = () => {
  const api = useApi();

  const getCode = async (data: OTPData, isAuth = false) => {
    try {
      return await api.post<{ message: string }>('/auth/send-otp/', isAuth, data);
    } catch (error) {
      console.error('Ошибка при отправке OTP:', error);
      throw error;
    }
  };

  const getRefreshToken = async (data: RefreshTokenData, isAuth = true) => {
    try {
      return await api.post<{ access: string; refresh: string }>(
        '/auth/refresh-token/',
        isAuth,
        data,
      );
    } catch (error) {
      console.error('Ошибка при обновлении токена:', error);
      throw error;
    }
  };

  const login = async (data: AuthData, isAuth = false) => {
    try {
      return await api.post<{ access: string; refresh: string }>(
        '/auth/login/',
        isAuth,
        data,
      );
    } catch (error) {
      console.error('Ошибка при авторизации:', error);
      throw error;
    }
  };

  return {
    getCode,
    getRefreshToken,
    login,
  };
};
